"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const merlin_button_1 = require("@travelnest/merlin.button");
const merlin_icon_1 = require("@travelnest/merlin.icon");
const getIconPositioning = (iconPosition) => {
    switch (iconPosition) {
        case 'before':
            return 'margin: auto;';
        case 'after':
            return 'margin: auto;';
        default:
            return '';
    }
};
const StyledButton = (0, styled_1.default)(merlin_button_1.Button) `
	padding: 5px;
	width: 70px;

	> div.merlin-button__content {
		margin-left: auto;
		margin-right: auto;
	}
`;
const StyledIcon = styled_1.default.div `
	width: 25px;
	height: 25px;
	position: relative;
	${({ iconPosition }) => getIconPositioning(iconPosition)}
`;
const StyledButtonContent = styled_1.default.div `
	display: flex;
	align-items: center;
`;
const ICON_PROPS_KEYS = ['icon', 'colour', 'background'];
const getIconProps = (props) => {
    // Default
    const out = { icon: 'check' };
    Object.keys(props).forEach((p) => {
        if (ICON_PROPS_KEYS.includes(p)) {
            out[p] = props[p];
        }
    });
    return out;
};
const IconButton = (props) => {
    const { children, iconPosition = 'before' } = props, attrs = __rest(props, ["children", "iconPosition"]);
    return React.createElement(StyledButton, Object.assign({ "data-testid": `icon-button--${attrs.icon}` }, attrs),
        React.createElement(StyledButtonContent, null,
            iconPosition === 'after' && children,
            React.createElement(StyledIcon, { iconPosition: iconPosition },
                React.createElement(merlin_icon_1.Icon, Object.assign({ "data-testid": "icon-button--icon-div" }, getIconProps(attrs)))),
            iconPosition === 'before' && children));
};
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.js.map